const Recommendation = {
    Section: {
        container: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            fontFamily: 'Inter, sans-serif',
            justifyContent: 'center',
            '@media (max-width: 600px)': {
                px: '20px',
            },
        },
        cardContainer: {
            display: 'flex',
            mt: '16px',
            width: '100%',
            gap: '10px',
            fontWeight: 700,
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
            '@media (max-width: 600px)': {
                maxWidth: '100%',
            },
        },
    },
    Card: {
        container: {
            display: 'flex',
            minWidth: '240px',
            flexDirection: 'column',
            justifyContent: 'space-between',
            backgroundColor: '#fbfcfe',
            flex: '1 1 0%',
            p: '24px',
            '@media (max-width: 600px)': {
                p: '20px',
            },
            '&:hover': {
                backgroundColor: '#fbfcfe',
                borderRadius: '4px',
                borderBottom: '5px solid #005cbc',
                boxShadow: '0px 2px 24px 8px rgba(0, 92, 188, 0.12)',
            },
        },
        subContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            flex: '1 1 0%',
        },
        header: {
            display: 'flex',
            width: '100%',
            gap: '16px',
            fontSize: '18px',
            color: '#3a3a3a',
            whiteSpace: 'nowrap',
            lineHeight: '28px',
            justifyContent: 'flex-start',
            '@media (max-width: 600px)': {
                whiteSpace: 'initial',
            },
        },
        img: {
            aspectRatio: '1',
            objectFit: 'contain',
            objectPosition: 'center',
            width: '48px',
            borderRadius: '50%',
            alignSelf: 'flex-start',
        },
        title: {
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            flex: '1 1 0%',
        },
        description: {
            color: '#3a3a3a',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '22px',
            mt: '12px',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minHeight: '88px', // Ensures 4 lines of text (22px line height * 4)
        },
        tags: {
            container: {
                display: 'flex',
                mt: '12px',
                width: '100%',
                alignItems: 'flex-start',
                gap: '4px',
                fontSize: '12px',
                color: '#000',
                fontWeight: 400,
                justifyContent: 'flex-start',
                flexWrap: 'wrap',
            },
            tag: {
                lineHeight: '18px',
                borderRadius: '4px',
                backgroundColor: 'rgba(204, 234, 246, 1)',
                minHeight: '24px',
                gap: '2px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                p: '3px 8px',
                '@media (max-width: 600px)': {
                    whiteSpace: 'initial',
                },
            },
        },
        buttons: {
            container: {
                display: 'flex',
                mt: '12px',
                width: '100%',
                flexDirection: 'column',
                fontSize: '14px',
                lineHeight: 1,
                justifyContent: 'flex-end',
            },
            primary: {
                borderRadius: '24px',
                backgroundColor: '#005cbc',
                color: '#fff',
                width: '100%',
                minHeight: '32px',
                justifyContent: 'center',
                textTransform: 'none',
            },
            secondary: {
                mt: '12px',
                color: '#005cbc',
                width: '100%',
                minHeight: '32px',
                justifyContent: 'center',
                textTransform: 'none',
                '&:hover': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
        },
    },
    TabNavigation: {
        container: {
            borderBottom: '1px solid rgba(215, 229, 248, 1)',
            display: 'flex',
            width: '100%',
            alignItems: 'flex-start',
            fontSize: '14px',
            color: '#616161',
            fontWeight: 400,
            lineHeight: 1,
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
            '@media (max-width: 600px)': {
                maxWidth: '100%',
            },
        },
        tab: (isActive) => ({
            cursor: isActive ? 'default' : 'pointer',
            borderBottom: isActive ? '2px solid #005cbc' : '1px solid rgba(215, 229, 248, 1)',
            display: 'flex',
            minHeight: '32px',
            overflow: 'hidden',
            fontWeight: isActive ? 700 : 400,
            justifyContent: 'flex-start',
            whiteSpace: 'nowrap',
            marginRight: '16px',
            '@media (max-width: 600px)': {
                whiteSpace: 'initial',
            },
        }),
        tabContent: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: 'center',
            height: '100%',
            p: '4px 8px',
        },
        icon: {
            aspectRatio: '1',
            objectFit: 'contain',
            objectPosition: 'center',
            width: '16px',
            alignSelf: 'stretch',
            margin: 'auto 0',
        },
        text: {
            alignSelf: 'stretch',
            margin: 'auto 0',
        },
    },
};

export default Recommendation;
